import { render, staticRenderFns } from "./OpenMarketDetail.vue?vue&type=template&id=6e0c847c&scoped=true"
import script from "./OpenMarketDetail.vue?vue&type=script&lang=js"
export * from "./OpenMarketDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c847c",
  null
  
)

export default component.exports